<div
    *ngIf="
        networkStatus?.ok === true &&
            dialerClientService.dialerService.missedPingCnt$
            | async as missedPingCnt
    "
    class="small mx-2 text-secondary font-italic"
    title="Dialer ping past due"
>
    <i
        class="fa fa-circle blink"
        [ngClass]="'text-' + (missedPingCnt > 1 ? 'danger' : 'warning')"
    ></i>
    Waiting for dialer response
</div>
<div
    *ngIf="networkStatus?.ok === false"
    class="d-flex flex-row justify-content-between mt-3 mx-2 w-100"
>
    <div class="font-weight-bold font-italic">
        <i class="fa fa-exclamation-triangle text-warning"></i>
        &nbsp;{{ dialerStatusMsg }}
    </div>
    <div class="pb-2">
        <button
            (click)="resetDialer()"
            [disabled]="resetting"
            class="btn btn-secondary"
            style="font-size: 12px; padding: 2px"
            title="Attempt connecting to dialer"
        >
            <i class="fa fa-sync"></i>&nbsp;Retry
        </button>
    </div>
</div>
